import React from "react";
import CreatableSelect from "react-select/creatable";
import { v4 as uuidv4 } from "uuid";
import { useDispatch, useSelector } from "react-redux";
import Form from "react-bootstrap/Form";
import { useParams } from "react-router-dom";
import EventHandler from "./EventHandler";
import {
  selectEventHandlers,
  selectWorkflowEventListener,
  setEventHandlers,
} from "../../../store/slices/projectSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinusCircle } from "@fortawesome/free-solid-svg-icons";

export default function Listener({ setListener, removeEventListener }) {
  const { workflowUUID, listenerUUID, event } = useParams();
  const listenerState = useSelector(
    selectWorkflowEventListener(workflowUUID, listenerUUID)
  );
  const eventHandlers = useSelector(selectEventHandlers);
  const dispatch = useDispatch();

  return (
    listenerState && (
      <div>
        {listenerState.EventHandlerUUID ? (
          <div className="mt-3">
            {eventHandlers.find(
              (eh) => eh.UUID === listenerState.EventHandlerUUID
            )?.StopPropagation === false &&
              event !== "form-render" && (
                <Form.Group
                  controlId={`${listenerState.UUID}-stop-propagation-checkbox`}
                >
                  <Form.Check
                    type="checkbox"
                    className="form-check mx-2 my-2"
                    checked={listenerState.StopPropagation || false}
                    onChange={() =>
                      setListener({
                        ...listenerState,
                        StopPropagation: !listenerState.StopPropagation,
                      })
                    }
                    label="Do not run subsequent handlers if any condition is met?"
                  />
                </Form.Group>
              )}
            <EventHandler
              key={listenerState.EventHandlerUUID}
              event={event}
              uuid={listenerState.EventHandlerUUID}
            />
          </div>
        ) : (
          <div className="mt-3 listener-tab">
            <label className="form-label">Listener label</label>
            <CreatableSelect
              menuPortalTarget={document.body}
              menuPlacement="auto"
              styles={{
                menu: (base) => ({
                  ...base,
                  width: "max-content",
                  minWidth: "100%",
                  boxShadow: "0px 0px 8px 0px #444",
                }),
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
              autoFocus
              options={eventHandlers
                .filter((eh) => eh.IsModule)
                .map((eh) => ({
                  value: eh.UUID,
                  label: eh.Label,
                }))}
              placeholder="Select an event handler module or start typing to create a new one"
              onChange={(option) => {
                setListener({
                  ...listenerState,
                  EventHandlerUUID: option.value,
                });
              }}
              isValidNewOption={(v) => v}
              onCreateOption={(option) => {
                const UUID = uuidv4();
                const rowUUID = uuidv4();
                setListener({ ...listenerState, EventHandlerUUID: UUID });
                dispatch(
                  setEventHandlers([
                    ...eventHandlers,
                    {
                      UUID,
                      Label: option,
                      StopPropagation: false,
                      Rules: [
                        {
                          UUID: rowUUID,
                          Label: `Rule-${rowUUID.slice(0, 4)}`,
                          Conditions: [],
                          Actions: [],
                        },
                      ],
                      IsModule: false,
                    },
                  ])
                );
              }}
            />
          </div>
        )}
        <button
          type="button"
          className="btn btn-outline-danger mt-2 float-end border-0"
          onClick={() => {
            removeEventListener(listenerState);
          }}
        >
          <FontAwesomeIcon icon={faMinusCircle} /> Remove{" "}
          {event === "form-render" ? "panel" : "listener"}
        </button>
      </div>
    )
  );
}
